module.exports = __webpack_public_path__ + "img/logo.c15228cf.png";